import React, { useState } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { FilterButton } from 'Components/frameworks/filter-button/FilterButton';
import { Notification } from 'Components/frameworks/notification/Notification';
import { Text } from 'Components/frameworks/text/Text';
import { ActivitiesList } from 'Components/widgets/activities-list/ActivitiesList';
import { AvailabilityBadge } from 'Components/widgets/availability-badge/AvailabilityBadge';
type Props = {
  category: ActivitiesCategoryEntity;
  className?: string;
  colsNumber?: number;
  hasRentals?: boolean;
  message: {
    title?: string;
    subtitle?: string;
  };
};
export const ActivitiesFilteredList = ({
  category,
  className,
  colsNumber = 3,
  hasRentals = false,
  message,
}: Props) => {
  const [filter, setFilter] = useState<string | null>(null);

  if (!category.activities?.length) {
    return null;
  }

  const { activities, categories } = category;
  const shouldDisplayNotification =
    message?.title && message?.subtitle && !!category?.onlineBookableCount;
  const notEmptyCategories = (categories || []).filter((c) =>
    c.activities?.some((a) => !a.isIncluded),
  );
  return (
    <div className={classnames(className)}>
      <div className="mb-20 md:flex">
        {shouldDisplayNotification && (
          <Notification
            className="mb-20 md:order-1 md:mb-0"
            data-testid="specialOfferBlock"
            iconName={ICONS.SPECIAL_OFFERS}
          >
            <Text
              className="font-bold text-sienna"
              data-testid="specialOfferText-title"
              text={message?.title || ''}
              theme="text-sans-n1"
            />
            <Text
              data-testid="specialOfferText-subtitle"
              text={message?.subtitle || ''}
              theme="text-sans-n1"
            />
          </Notification>
        )}
        <p className="flex flex-1 items-center gap-5 text-14 font-bold text-orange">
          <AvailabilityBadge isOnDemand />
          {t('common.onDemand')}
        </p>
      </div>

      {notEmptyCategories.length > 1 && (
        <div className="scroll-x scrollbar-hidden">
          <ul className="-m-5 mb-20 flex">
            <li className="p-5">
              <FilterButton isActive={!filter} onClick={() => setFilter(null)}>
                {t('common.activities.seeAll')}
              </FilterButton>
            </li>
            {notEmptyCategories.map((cat) => (
              <li className="p-5" key={cat.id}>
                <FilterButton isActive={filter === cat.id} onClick={() => setFilter(cat.id)}>
                  {cat.name}
                </FilterButton>
              </li>
            ))}
          </ul>
        </div>
      )}

      <ActivitiesList
        activities={
          filter ? activities.filter((a) => a.categoriesIds.includes(filter)) : activities
        }
        category={category}
        colsNumber={colsNumber}
        hasRentals={hasRentals}
      />
    </div>
  );
};
